import { httpGet } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { PointSummary } from './types';

/**
 * Retrieves gamification points summary for user
 *
 * @method getPointSummary
 * @memberof Gamification
 * @returns {Promise<PointSummary | null>} - Summary of gamification points
 */

export const getPointSummary = async (): Promise<PointSummary | null> => {
  const url = `${Constants.BACKEND_URL}/get-point-summary`;

  return httpGet(url, {})
    .then((response) => {
      if (response && response.data) {
        const { title, level, points, level_threshold } = response.data;

        const progress = level != -1 ? Math.floor((points / level_threshold) * 100) : 0;

        return {
          title,
          level,
          points,
          threshold: level_threshold,
          progress,
        };
      }
      return null;
    })
    .catch((error) => {
      throw Error(error);
    });
};
